import React, { MouseEvent } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Grid, Card, Icon } from '@printdeal/ui-library';
import { Image } from '@unpic/react';
import { HitProp } from '../../../algolia-search/types';

export interface ClickEventProp extends Partial<Pick<HitProp,
'highlightedTextProductName' |
'productName' |
'featuredImage' |
'image' |
'title' |
'objectID' |
'path' |
'parentProduct'
>> {
  queryID?: string | null;
  index?: string | null;
  position?: number;
  staticHeaderInView?: boolean;
  userId?: string;
}

interface ProductSearchResultsProp {
  products?: HitProp[];
  clickEvent?: (
    prop: ClickEventProp,
    event?: MouseEvent<HTMLButtonElement>
  ) => void;
  dispatchProductsClickGA4?: Function;
}

const ProductSearchResults = ({
  products = [],
  clickEvent = () => { },
  dispatchProductsClickGA4 = () => { },
}: ProductSearchResultsProp) => {
  const productList = products?.filter(({ path }) => Boolean(path)) || [];
  if (!productList || productList.length === 0) {
    return null;
  }

  const dispatchProductsClickHandler = (hit: HitProp, position: number) => {
    dispatchProductsClickGA4(hit.productName, position + 1, 'product');
    clickEvent({ ...hit, position });
  };

  return (
    <Grid className="pd-items-stretch pd-gap-4 md:pd-grid-cols-2">
      {productList.map((hit: HitProp, index: number) => (
        <Card
          key={hit.objectID}
          variant="horizontal"
          size="sm"
          link={<GatsbyLink to={hit.path} onClick={() => dispatchProductsClickHandler(hit, index)} />}
          title={hit.productName}
          image={(
            (hit.image && hit.image.src)
              ? (
                <Image
                  src={hit.image.src}
                  alt={hit.productName}
                  aspectRatio={1}
                  objectFit="cover"
                  layout="constrained"
                  width={128}
                />
              )
              : <Icon icon="image" size="2xl" className="pd-text-dim-500" />
          )}
        />
      ))}
    </Grid>
  );
};

export default ProductSearchResults;
